import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Sat, 08 Nov 2025 13:59 PM ( CET ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.hu2emu0_oAk2awPvUa92w-K85k2Z_nXCx_sLQTvXLA1pjUfguHY5FZUmVl-cDnDUA3o5XngCbXrmEOc6riIhx517kshqQrm10G3s9vZa2Op088beL843zjNa7SPb8RzeKYv_6oTT-fPlDP8C-XXb16hFUm4yto4Z8TqGfzIYFCKvBwfccfLkzZj0EHiao5SNIYy-dShQaXq88_O8e_Ia7OI2V07Nm5PiVTQ-x4TiGVgYOybyNfZX_sN6_SdR7H10b7fm-JzSOEmf9NZoQ_xvxiQBw6cIo_KN6hrMYw1k8pVrnw7bMtn30H3d5jggOubNEwp2chqn1np9-oE3cYAE2VCDcK1a07dAmg",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2025-11-15T12:59:30.804332Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2025-11-08T12:59:25+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.hu2emu0_oAk2awPvUa92w-K85k2Z_nXCx_sLQTvXLA1pjUfguHY5FZUmVl-cDnDUA3o5XngCbXrmEOc6riIhx517kshqQrm10G3s9vZa2Op088beL843zjNa7SPb8RzeKYv_6oTT-fPlDP8C-XXb16hFUm4yto4Z8TqGfzIYFCKvBwfccfLkzZj0EHiao5SNIYy-dShQaXq88_O8e_Ia7OI2V07Nm5PiVTQ-x4TiGVgYOybyNfZX_sN6_SdR7H10b7fm-JzSOEmf9NZoQ_xvxiQBw6cIo_KN6hrMYw1k8pVrnw7bMtn30H3d5jggOubNEwp2chqn1np9-oE3cYAE2VCDcK1a07dAmg'

// {
//   "access_token": "v2.local.zM64LLpL9auJwK5jjyX90nJ0obXOnYpId3XX87hzHxDxQUZv1MXjfTBKOOOZ6wWUqRVF30hxFffKHRTy0aN2q2VobA6LtiIFbQzvirwXaMPll_bVtXIYPMMS3loC2mwC9wD2AJvm5SxTxtk897nPVc8HS6_2kvVgMw8lue7qAUR5K8BTN6IJIPh6fQ-WJnRh4CRjW_MTaiVjsV2GtPjsEam5TYUjzh79zgP3YQWsLMgWHX85Zu-FTtrCCrkG_3_dSgSKG6Tl6vtSsh6xo-SqBOd3zQ_poOVomRFI9tzDabbdjjjYIl5AIGL9N6QNUh3A9dAPV69FGMK4imguzUwlwSC2UVfZ",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2025-11-15T13:00:33.542123Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2025-11-08T13:00:31+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.zM64LLpL9auJwK5jjyX90nJ0obXOnYpId3XX87hzHxDxQUZv1MXjfTBKOOOZ6wWUqRVF30hxFffKHRTy0aN2q2VobA6LtiIFbQzvirwXaMPll_bVtXIYPMMS3loC2mwC9wD2AJvm5SxTxtk897nPVc8HS6_2kvVgMw8lue7qAUR5K8BTN6IJIPh6fQ-WJnRh4CRjW_MTaiVjsV2GtPjsEam5TYUjzh79zgP3YQWsLMgWHX85Zu-FTtrCCrkG_3_dSgSKG6Tl6vtSsh6xo-SqBOd3zQ_poOVomRFI9tzDabbdjjjYIl5AIGL9N6QNUh3A9dAPV69FGMK4imguzUwlwSC2UVfZ'

// {
//   "access_token": "v2.local.WhX88rfNkNuc5jXojEqTB9DPxZDgdnaIHui0GZ1fU8RhVOn46uXNU1XDjtq0-JhX2Vs2CvmQIzcbx9yd7PFiiKL-TRMiUwVAevRo41BhL_ypeFLp5pnVsFXVLiueK33i2jSJZhyoyjWvjVptbobcLmS-4MHViwsgRXx--l26yrJuiKHIRZ06XcigF-D-HBRXX7yfeiHAWr6HVi7zEk0OPSfUGolBNtpkNyckgGVUTvp8Xk2_Py1a34iOg05yiHcEFcpRxftDxlGdNucDDBFD6_Z_jz-w",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2025-11-15T13:01:40.090586Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.WhX88rfNkNuc5jXojEqTB9DPxZDgdnaIHui0GZ1fU8RhVOn46uXNU1XDjtq0-JhX2Vs2CvmQIzcbx9yd7PFiiKL-TRMiUwVAevRo41BhL_ypeFLp5pnVsFXVLiueK33i2jSJZhyoyjWvjVptbobcLmS-4MHViwsgRXx--l26yrJuiKHIRZ06XcigF-D-HBRXX7yfeiHAWr6HVi7zEk0OPSfUGolBNtpkNyckgGVUTvp8Xk2_Py1a34iOg05yiHcEFcpRxftDxlGdNucDDBFD6_Z_jz-w'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
